exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-whole-border th[data-v-56af353c]{padding:12px 6px}.many-field-tr td[data-v-56af353c]{padding:6px}.progress-btn[data-v-56af353c]{width:84px;padding:6px 0;margin:2px;font-weight:700;font-size:.8rem}.bid-state[data-v-56af353c],.progress-btn[data-v-56af353c]{border-radius:3px;display:inline-block}.bid-state[data-v-56af353c]{margin:2px 0;color:#fff;width:76px;padding:4px}.bid-state-ing[data-v-56af353c]{background-color:#1c7cd5}.bid-state-ok[data-v-56af353c]{background-color:#5cb85c}.bid-state-no[data-v-56af353c]{background-color:#f0ad4e}", ""]);

// exports
